import { Consent, ConsentPermission } from 'app/area/user-profile/my-notifications/types';

export const ACTION = {
  REQUEST_DELETE_CONSENT: 'MY_NOTIFICATIONS:REQUEST_DELETE_CONSENT',
  RECEIVE_DELETE_CONSENT: 'MY_NOTIFICATIONS:RECEIVE_DELETE_CONSENT',
  FAIL_DELETE_CONSENT: 'MY_NOTIFICATIONS:FAIL_DELETE_CONSENT',

  REQUEST_VERIFY_CODE: 'MY_NOTIFICATIONS:REQUEST_VERIFY_CODE',
  RECEIVE_VERIFY_CODE: 'MY_NOTIFICATIONS:RECEIVE_VERIFY_CODE',
  FAIL_VERIFY_CODE: 'MY_NOTIFICATIONS:FAIL_VERIFY_CODE',

  REQUEST_SAVE_SUBSCRIPTION: 'MY_NOTIFICATIONS:REQUEST_SAVE_SUBSCRIPTION',
  RECEIVE_SAVE_SUBSCRIPTION: 'MY_NOTIFICATIONS:RECEIVE_SAVE_SUBSCRIPTION',
  FAIL_SAVE_SUBSCRIPTION: 'MY_NOTIFICATIONS:FAIL_SAVE_SUBSCRIPTION',

  REQUEST_LOAD_PERMISSION: 'MY_NOTIFICATIONS:REQUEST_LOAD_PERMISSION',
  RECEIVE_LOAD_PERMISSION: 'MY_NOTIFICATIONS:RECEIVE_LOAD_PERMISSION',
  FAIL_LOAD_PERMISSION: 'MY_NOTIFICATIONS:FAIL_LOAD_PERMISSION',

  REQUEST_LOAD_CONSENT: 'MY_NOTIFICATIONS:REQUEST_LOAD_CONSENT',
  RECEIVE_LOAD_CONSENT: 'MY_NOTIFICATIONS:RECEIVE_LOAD_CONSENT',
  FAIL_LOAD_CONSENT: 'MY_NOTIFICATIONS:FAIL_LOAD_CONSENT',

  REQUEST_LOAD_CONSENTS: 'MY_NOTIFICATIONS:REQUEST_LOAD_CONSENTS',
  RECEIVE_LOAD_CONSENTS: 'MY_NOTIFICATIONS:RECEIVE_LOAD_CONSENTS',
  FAIL_LOAD_CONSENTS: 'MY_NOTIFICATIONS:FAIL_LOAD_CONSENTS',

  PROCESS_CONSENT_FAILED: 'MY_NOTIFICATIONS:PROCESS_CONSENT_FAILED',

  CLEAR_CONSENT: 'MY_NOTIFICATIONS:CLEAR_CONSENT',
  CLEAR_VALIDATION: 'MY_NOTIFICATIONS:CLEAR_VALIDATION'
};

export class RequestDeleteConsent {
  public type: string = ACTION.REQUEST_DELETE_CONSENT;
}

export class ReceiveDeleteConsent {
  public type: string = ACTION.RECEIVE_DELETE_CONSENT;
}

export class FailDeleteConsent {
  public type: string = ACTION.FAIL_DELETE_CONSENT;
}

export class RequestVerifyCode {
  public type: string = ACTION.REQUEST_VERIFY_CODE;
}

export class ReceiveVerifyCode {
  public type: string = ACTION.RECEIVE_VERIFY_CODE;
}

export class FailVerifyCode {
  public type: string = ACTION.FAIL_VERIFY_CODE;
}

export class RequestSaveSubscription {
  public type: string = ACTION.REQUEST_SAVE_SUBSCRIPTION;
}

export class ReceiveSaveSubscription {
  public type: string = ACTION.RECEIVE_SAVE_SUBSCRIPTION;
}

export class FailSaveSubscription {
  public type: string = ACTION.FAIL_SAVE_SUBSCRIPTION;
}
export class RequestLoadPermission {
  public type: string = ACTION.REQUEST_LOAD_PERMISSION;
}

export class ReceiveLoadPermission {
  public type: string = ACTION.RECEIVE_LOAD_PERMISSION;
  constructor(public permission: ConsentPermission) { }
}

export class FailLoadPermission {
  public type: string = ACTION.FAIL_LOAD_PERMISSION;
}

export class RequestLoadConsents {
  public type: string = ACTION.REQUEST_LOAD_CONSENTS;
}

export class ReceiveLoadConsents {
  public type: string = ACTION.RECEIVE_LOAD_CONSENTS;
  constructor(public consents: Consent[]) { }
}

export class FailLoadConsents {
  public type: string = ACTION.FAIL_LOAD_CONSENTS;
}

export class RequestLoadConsent {
  public type: string = ACTION.REQUEST_LOAD_CONSENT;
}

export class ReceiveLoadConsent {
  public type: string = ACTION.RECEIVE_LOAD_CONSENT;
  constructor(public consent: Consent) { }
}

export class FailLoadConsent {
  public type: string = ACTION.FAIL_LOAD_CONSENT;
}

export class ProcessConsentFailed {
  public type: string = ACTION.PROCESS_CONSENT_FAILED;
  public errors: any;
  constructor(errors: any) {
    this.errors = errors;
  }
}

export class ClearConsent {
  public type: string = ACTION.CLEAR_CONSENT;
}

export class ClearValidation {
  public type: string = ACTION.CLEAR_VALIDATION;
  public formName: string;

  constructor(formName: string) {
    this.formName = formName;
  }
}
